import { Routes } from '@front-app/constants/routes';
import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { PhoenixRouteConfig } from '../Model';

const children: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string { return i18n.t('page.title.community-management') as string; },
		},
		path: 'communities',
		name: Routes.COMMUNITY_MANAGEMENT,
		component: () => import(/* webpackChunkName: "community-management" */ '@front-app/views/csr/CommunityManagement.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string { return i18n.t('page.title.csr-queries') as string; },
		},
		path: 'community-queries',
		name: Routes.CHANNEL_REPORTS,
		redirect: { name: Routes.CHANNEL_REPORTS_FOR_EVENT },
	},
	{
		meta: {
			title(i18n: VueI18n): string { return i18n.t('page.title.csr-queries') as string; },
		},
		path: 'community-queries/:eventId?',
		name: Routes.CHANNEL_REPORTS_FOR_EVENT,
		component: () => import(/* webpackChunkName: "community-queries" */ '@front-app/views/csr/CommunityQueries.vue'),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				eventId: route.params.eventId,
				fromDate: (route.query.fromDate && typeof route.query.fromDate === 'string') ? new Date(route.query.fromDate) : undefined,
				toDate: (route.query.toDate && typeof route.query.toDate === 'string') ? new Date(route.query.toDate) : undefined,
				action: route.query.action,
			};
		},
	},
];

export const csrRoutes: PhoenixRouteConfig[] = [
	{
		name: Routes.CSR,
		redirect: { name: Routes.COMMUNITY_MANAGEMENT },
		path: 'csr',
		meta: {
			title(): string { return 'CSR'; },
			trappRoute(): string {
				return '/CSR.csr';
			},
		},
		component: () => import(/* webpackChunkName: "csr-settings" */ '@front-app/views/csr/CsrMain.vue'),
		children,
	},
];
